import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { AuthenticationService } from '../../Services/index';
import { User } from '../../Models/index';

import { contentHeaders } from '../../Core/Headers';

@Component({

    templateUrl: './forgot.component.html',
    styleUrls: ['./login.css']


})

export class ForgotpasswordComponent implements OnInit {
    //model: any = {};
    IsmailSend = true;
    submitted = true;
    Error = true;
    loading = false;
    returnUrl: string;
    resetGuid: string = "";
    isResetPassword: boolean = false;
    isResetPasswordError: boolean = false;
    errorMessage : string = "";
    user: any = null;
    passwordLength : number = 4;
    public model = new User();
    public errorMsg = '';

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService
        //private alertService: AlertService
    ) { }

    ngOnInit() {
        this.user = new User();
        this.submitted = true;
        this.Error = true;
        this.route.params.subscribe(params => {
            if (params['token']) {
                //alert(params['token'])
            }
        });
        this.route.queryParams.subscribe((params) => {
            window.localStorage.removeItem('currentUser');
            window.localStorage.removeItem('pagedetails')
            window.localStorage.removeItem('id_token');
            if (params['resetGuid'] != null) {
                this.resetGuid = params['resetGuid'];
                this.isResetPassword = true;
                this.authenticationService.getUserByResetPasswordLink(this.resetGuid)
                    .subscribe(
                    data => {
                        this.loading = false;
                        if (data) {
                            this.user = data;
                            this.user.password = "";
                            this.user.newPassword = "";
                            this.isResetPasswordError = false;
                            console.log("user is: ", this.user);
                        } else {
                            this.isResetPassword = false;
                            this.isResetPasswordError = true;
                            this.errorMessage = "URL is expired";
                        }
                    },
                    error => {
                        this.isResetPassword = false;
                        this.isResetPasswordError = true;
                        this.errorMessage = "Something went wrong, please try again later.";
                        this.loading = false;
                        console.log("error occured: " + error);
                    });
            } else {
                this.resetGuid = '';
                this.isResetPassword = false;
            }
           
        });
    }
	updatePassword(event: any) {
        console.log('updating password: ', this.user);
        this.loading = true;
        this.isResetPasswordError = true;
        if( this.user.password != null && this.user.password != '' 
            && this.user.password.length >= this.passwordLength
            && this.user.newPassword.length >= this.passwordLength
            && this.user.password == this.user.newPassword){
             this.authenticationService.updatePassword(this.user)
            .subscribe(
            data => {
                this.loading = false;
                if (data) {
                    console.log('data is coming: ', data);
                     this.isResetPasswordError = false;
                    this.router.navigateByUrl('/login');
                } else {

                    this.isResetPasswordError = true;
                     this.errorMessage = "Something went wrong, please try again later.";
                }
                 this.loading = false;
            },
            error => {
                this.Error = false;
                this.isResetPasswordError = true;
                this.loading = false;
                 this.errorMessage = "Something went wrong, please try again later.";
                console.log("error occured: " + error);
            });
        }
        else{
            this.isResetPasswordError = true;
            if(this.user.password == null || this.user.password.length < this.passwordLength) {
                  this.errorMessage = "Password lenght must be greater than or equal to " + this.passwordLength + "." ;
            }
            else  if(this.user.newPassword == null || this.user.newPassword.length < this.passwordLength) {
                  this.errorMessage = "Please confirm the password." ;
            }
            else  if(this.user.newPassword != this.user.password) {
                  this.errorMessage = "Password and Confirm Password must be same." ;
            }
             this.loading = false;
        }

    }

	forgotpassword(event: any) {
        console.log('Submitting forget password');
        this.loading = true;
        this.IsmailSend = true;
        this.Error = true;
        this.authenticationService.forgotpassword(this.model.email)
            .subscribe(
            data => {
                
                this.loading = false;
                if (data) {
                    this.IsmailSend = false;
                } else {

                    this.Error = false;
                }
                // alert(JSON.stringify(data));
                
                
                // store user details and jwt token in local storage to keep user logged in between page refreshes
               // window.localStorage.setItem('currentUser', JSON.stringify(data));
               // window.localStorage.setItem('id_token', data.access_token);

                //this.router.navigate(['/home']);
            },
            error => {
                this.Error = false;
                this.loading = false;
                console.log("error occured: " + error);
            });

    }
}
 


// WEBPACK FOOTER //
// ./src/app/Components/login/forgotpassword.component.ts